import { apiFetch } from "@/auth/apiClient";

export const getCourseExamHistory = async (params?: Record<string, any>) => {
  const qs = params ? new URLSearchParams(params as Record<string, string>).toString() : "";
  return apiFetch(`/lms/exam-attempts/my-history${qs ? `?${qs}` : ""}`, { method: "GET" });
};

export const getMockTestHistory = async (params?: Record<string, any>) => {
  const qs = params ? new URLSearchParams(params as Record<string, string>).toString() : "";
  return apiFetch(`/lms/mock-test-attempts/my-history${qs ? `?${qs}` : ""}`, { method: "GET" });
};
